module.exports = __webpack_public_path__ + "assets/img/statue-2.cd5433a3.png";